import { useEffect, useState } from "react";
import { FileMetadata } from "src/requests/files/types";
import { getFiles } from "../../../../requests/files/requestCreators";
import { useUserLogin } from "../../../../store/login/hooks/useSelectors";
import { UseFilesParams } from "../types";

type ReturnType = {
  files: FileMetadata[];
  setFiles(newFiles: FileMetadata[]): void;
  areFilesFetching: boolean;
  fetchFilesOnOpen(): void;
};

type UseFiles = (params: UseFilesParams) => ReturnType;

const useFiles: UseFiles = ({ editMode, clearLocalData, ...rest }) => {
  const userLogin = useUserLogin() ?? "";
  const [files, setFiles] = useState<FileMetadata[]>([]);
  const [areFilesFetching, setAreFilesFetching] = useState(false);

  const fetchFiles = (): void => {
    setAreFilesFetching(true);
    getFiles({ ...rest, userLogin })
      .then(({ data }) => {
        setFiles(data);
        clearLocalData();
      })
      .finally(() => setAreFilesFetching(false));
  };

  const fetchFilesOnOpen = (): void => {
    if (!files.length) fetchFiles();
  };

  useEffect(() => {
    if (editMode) {
      fetchFiles();
      return;
    }

    setFiles([]);
    clearLocalData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editMode]);

  return { files, areFilesFetching, setFiles, fetchFilesOnOpen };
};

export default useFiles;
